module.exports = __webpack_public_path__ + "media/svg-new/coins-e01a17dc.svg";